export default __webpack_public_path__ + "images/close.69fadd3e76289e682ca1edf86969ab66.svg";